import Axios, { AxiosRequestConfig } from 'axios';

import { baseApiUrl } from '../../../config';
import { AxiosError, handleAxiosRequest } from '../../../utils';

export const AXIOS_INSTANCE_NO_FADCODE = Axios.create({ baseURL: baseApiUrl });

export const customInstanceNoFadcode = <T>(config: AxiosRequestConfig): Promise<T> => {
  return handleAxiosRequest(AXIOS_INSTANCE_NO_FADCODE, config);
};

export type ErrorType<Error> = AxiosError<Error>;
